import { FC } from 'react';

import TableApplicationCreate from '../../../components/table/recruiting/tableApplicationCreate';

import styles from './applicationFormCreate.module.scss';

const ApplicationFormCreate: FC = () => {
	return (
		<div className={styles.vacancyCreateWrapper}>
			<TableApplicationCreate />
		</div>
	);
};

export default ApplicationFormCreate;
